import api from './api';

export const purchaseService = {
  getPurchaseRequests: async (token) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      const response = await api.get('/purchase-request/', { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

   createPurchaseRequest: async (payload) => {
    try {
      const response = await api.post('/purchase-request/', payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar solicitação de compra:', error);
      throw error;
    }
  },
};
